import React from "react";
import styles from "./initialAvatar.module.css";

const PALETTE = [
    { bg: "#eff4ff", color: "#2563eb" },
    { bg: "#ecfdf3", color: "#16a34a" },
    { bg: "#f4f1fe", color: "#7c3aed" },
    { bg: "#fffaeb", color: "#d97706" },
    { bg: "#fdf2f8", color: "#db2777" },
    { bg: "#f0fdfa", color: "#0d9488" },
    { bg: "#fef2f2", color: "#dc2626" },
    { bg: "#f0f9ff", color: "#0284c7" },
];

const PALETTE_DARK = [
    { bg: "rgba(37, 99, 235, 0.18)", color: "#60a5fa" },
    { bg: "rgba(34, 197, 94, 0.18)", color: "#4ade80" },
    { bg: "rgba(124, 58, 237, 0.18)", color: "#a78bfa" },
    { bg: "rgba(217, 119, 6, 0.18)", color: "#fbbf24" },
    { bg: "rgba(219, 39, 119, 0.18)", color: "#f472b6" },
    { bg: "rgba(13, 148, 136, 0.18)", color: "#2dd4bf" },
    { bg: "rgba(220, 38, 38, 0.18)", color: "#f87171" },
    { bg: "rgba(2, 132, 199, 0.18)", color: "#38bdf8" },
];

const hashIndex = (str: string) => {
    let h = 0;
    for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) | 0;
    return Math.abs(h) % PALETTE.length;
};

const initials = (name?: string) => {
    if (!name) return "?";
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return "?";
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

interface InitialAvatarProps {
    name?: string;
    size?: number;
}

export const InitialAvatar: React.FC<InitialAvatarProps> = ({ name = "", size = 40 }) => {
    const idx = hashIndex(name || "?");
    const isDark = (typeof document !== "undefined" && document.documentElement.getAttribute("data-theme") === "dark");
    const c = isDark ? PALETTE_DARK[idx] : PALETTE[idx];
    return (
        <span
            className={styles.avatar}
            style={{
                width: size,
                height: size,
                background: c.bg,
                color: c.color,
                fontSize: Math.round(size * 0.4),
            }}
        >
            {initials(name)}
        </span>
    );
};
